import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { AdminPromotionPage } from '@/pages/promotions/AdminPromotionPage'

export const Route = createFileRoute('/promotions/$initiativeId/national/')({
  component: withErrorBoundary(AdminPromotionPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
})
